<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" class="mr-2 mt-2">
        <v-card elevation="0" height="88vh" class="main-dashboard-115-card body-card">
          <v-card-text>
            <v-row>
              <v-col cols="3">
                <v-card height="15vh" class="data-card1" elevation="0">
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="2">
                        <v-icon color="darkColor" class="data-card-icon">
                          mdi-clock-time-four mdi-18px
                        </v-icon>
                      </v-col>
                      <v-col cols="2" class="mr-3">
                        <h2 class="data-card-title">ساعت کاری</h2>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="5">
                        <h2 class="data-card-content">
                          {{ dashboard800Time }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card height="15vh" class="data-card2" elevation="0">
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="2">
                        <v-icon color="darkColor" class="data-card-icon">
                          mdi-car-emergency mdi-18px
                        </v-icon>
                      </v-col>
                      <v-col cols="5" class="mr-3">
                        <h2 class="data-card-title">ماموریت های جاری</h2>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="2" class="text-left ml-2">
                        <h2 class="data-card-content">
                          {{ dashboard800CurrentMissionCount }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card height="15vh" class="data-card3" elevation="0">
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="2">
                        <v-icon color="darkColor" class="data-card-icon">
                          mdi-car-emergency mdi-18px
                        </v-icon>
                      </v-col>
                      <v-col cols="5" class="mr-3">
                        <h2 class="data-card-title">ماموریت های 19-10</h2>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="2" class="text-left ml-2">
                        <h2 class="data-card-content">
                          {{ dashboard8001019MissionCount }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card height="15vh" class="data-card4" elevation="0">
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="2">
                        <v-icon color="darkColor" class="data-card-icon">
                          mdi-car-emergency mdi-18px
                        </v-icon>
                      </v-col>
                      <v-col cols="5" class="mr-3">
                        <h2 class="data-card-title">ماموریت های اعزام شده</h2>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="2" class="text-left ml-2">
                        <h2 class="data-card-content">
                          {{ dashboard800endMissionCount }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-img :src="dashboardIMG" contain class="second-row-img"></v-img>
                    </v-col>
                  </v-row>
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="12" class="mt-7">
                        <v-row>
                          <v-col cols="1"></v-col>
                          <v-col cols="2">
                            <v-icon color="lightColor" class="data-card-icon">
                              mdi-clock-time-four mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="7">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{ dashboardSendAverge }}
                                </h2>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-title">میانگین زمان اعزام</h2>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="mt-12">
                        <v-row>
                          <v-col cols="1"></v-col>
                          <v-col cols="2">
                            <v-icon color="lightColor" class="data-card-icon">
                              mdi-clipboard-text mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="7">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{ dashboardFollowUpFinishCount }}
                                </h2>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-title">
                                  تعداد ماموریت های ثبت توسط پیگیری
                                </h2>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card height="265px" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">
                      mdi-clipboard-list mdi-48px
                    </v-icon>
                    <span class="chart-title-content">اولویت ها</span>
                  </v-row>
                  <v-card-text>
                    <div id="dashboard800PieRankChart" dir="rtl" style="width: inherit">
                      <highcharts :options="dashboard800PieRankChartOptions" ref="pieRank"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card height="265px" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">mdi-cog mdi-48px</v-icon>
                    <span class="chart-title-content">عملیات</span>
                  </v-row>
                  <v-card-text>
                    <div id="dashboard800PieOperationChart" dir="rtl" style="width: inherit">
                      <highcharts :options="dashboard800PieOperationChartOptions" ref="pieRank"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card height="15vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-img :src="dashboardIMG2" contain class="second-row-img2"></v-img>
                    </v-col>
                  </v-row>
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col class="third-row-space">
                        <v-row>
                          <v-col cols="1"></v-col>
                          <v-col cols="2">
                            <v-icon color="lightColor" class="data-card-icon">
                              mdi-phone mdi-flip-h mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="7">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{ dashboard800ActiveCode }}
                                </h2>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-title">کدهای فعال</h2>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="third-row-space">
                        <v-row>
                          <v-col cols="1"></v-col>
                          <v-col cols="2">
                            <v-icon color="lightColor" class="data-card-icon">
                              mdi-phone mdi-flip-h mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="7">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{ dashboard800ReadyCode }}
                                </h2>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-title">کدهای آماده</h2>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="third-row-space">
                        <v-row>
                          <v-col cols="1"></v-col>
                          <v-col cols="2">
                            <v-icon color="lightColor" class="data-card-icon">
                              mdi-map-marker mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="7">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{ dashboard800OutOfServiceCode }}
                                </h2>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-title">کدهای 7-10</h2>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="third-row-space">
                        <v-row>
                          <v-col cols="1"></v-col>
                          <v-col cols="2">
                            <v-icon color="lightColor" class="data-card-icon">
                              mdi-clock-time-four mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="7">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{ dashboard800LackOfCode }}
                                </h2>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-title">ماموریت های ثبت فاقدی</h2>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="third-row-space">
                        <v-row>
                          <v-col cols="1"></v-col>
                          <v-col cols="2">
                            <v-icon color="lightColor" class="data-card-icon">
                              mdi-clock-time-four mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="7">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{ dashboard800LocationConfirmationCode }}
                                </h2>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-title">ماموریت های ثبت موقعیت</h2>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card height="265px" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">
                      mdi-clipboard-list mdi-48px
                    </v-icon>
                    <span class="chart-title-content">ماموریت ها</span>
                  </v-row>
                  <v-card-text>
                    <div id="dashboard800LineMissionChart" dir="rtl" style="width: inherit">
                      <highcharts :options="dashboard800LineMissionChartOptions" ref="lineMission"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card height="265px" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">
                      mdi-clipboard-list mdi-48px
                    </v-icon>
                    <span class="chart-title-content">تماس ها</span>
                  </v-row>
                  <v-card-text>
                    <div id="dashboard800LineMissionChart" dir="rtl" style="width: inherit">
                      <highcharts :options="dashboard800LineCallChartOptions" ref="lineCall"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import AlertComponent from '../../components/AlertComponent.vue';
import UserNotificationMixin from '@/Mixins/800/userNotification.mixin';
import Dashboard800Helper from '@/Helpers/800/Dashboard800Helper.js';
import SharedHelper from '@/Helpers/Shared';
import DashboardMixin from '@/Mixins/Dashboard/DashboardMixin.js';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
export default {
  name: 'Dashboard800View',
  title: 'داشبورد 800',
  components: { AlertComponent },
  mixins: [
    Dashboard800Helper,
    SharedHelper,
    DashboardMixin,
    snackBar,
    ShearedMixin,
    UserNotificationMixin,
  ],
  created() {
    this.$root.$refs.Dashboard800 = this;
    this.$mainSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
  },
  beforeDestroy() {
    clearInterval(this.dashboard800TimeInterval);
    this.dashboard800TimeInterval = null;
    this.$mainSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);

    delete this.$root.$refs.Dashboard800;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.get800DashboardFunction();
    },
    fNotifyOutOfService: function (data) {
      switch (data?.type) {
        case 1:
          this.showTostMessage2(data?.text, 'ambulance107s', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        case 2:
          this.showTostMessage2(data?.text, '', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        default:
          break;
      }
      this.onGetAllUserNotificationOnSignal();
    },
  },
};
</script>
<style scoped>
.main-dashboard-115-card {
  border-radius: 10px !important;
  border: 1px solid #2edf93 !important;
}

.body-card {
  overflow: hidden;
}

.body-card:hover {
  overflow-y: auto;
}

.detail-115-dashboard-card {
  background: var(--background-color) !important;
  border-radius: 15px !important;
}



.data-card1 {
  background: linear-gradient(250deg, var(--dark-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card2 {
  background: linear-gradient(250deg, var(--light-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card3 {
  background: linear-gradient(250deg, var(--one-field-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card4 {
  background: linear-gradient(250deg, var(--new-call-effect) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

>>>.highcharts-credits {
  /*color: black !important;*/
  fill: var(--background-color) !important;
  cursor: auto !important;
}

>>>.highcharts-background {
  fill: var(--background-color) !important;
}

>>>.highcharts-legend-item text {
  fill: var(--dark-color) !important;
}

>>>.highcharts-label span {
  fill: var(--dark-color) !important;
  color: var(--dark-color) !important;
  z-index: 1 !important;
}

.card-info-send-mission-scroll {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

>>>.second-row-img {
  position: absolute;
  margin-top: 22%;
}

>>>.second-row-img2 {
  position: absolute;
  margin-top: 1.5%;
}

.data-card-icon {
  background: white;
  padding: 10px !important;
  border-radius: 50% !important;
  margin-top: 2.5vh;
}

.data-card-title {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  padding-top: 3.3vh !important;
  margin-right: -2vh !important;
}

.data-card-content {
  color: white;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  padding-top: 3.5vh !important;
  letter-spacing: 1.3px;
}

.data-card-calls-count-content {
  color: #2d3748;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  padding-top: 2vh !important;
  letter-spacing: 1.3px;
  position: relative !important;
}

.data-card-calls-count-title {
  color: #2d3748;
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
  margin-top: -2vh !important;
  position: relative !important;
}

.third-row-space {
  width: 20%;
  min-width: 20%;
  max-width: 20%;
}

.chart-title {
  position: absolute;
}

.chart-title-content {
  margin-right: -50px;
  margin-top: 8px;
  font-weight: 500;
  font-size: 15px;
  z-index: 1;
  color: var(--dark-color);
}

.chart-title-icon {
  z-index: 1;
  margin-right: 10px;
  margin-top: 4px;
}
</style>
